import { configure } from './config';
import { configureProcedures } from './iguazuRPC';

configure();
configureProcedures();
